/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/jsx-key */
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
// use @mui
import { useTheme } from '@mui/material/styles';
import { Stack, AppBar, Toolbar, IconButton, TextField, Autocomplete, Tooltip, Button, Menu, MenuItem } from '@mui/material';
import { isEmpty } from 'lodash';
// use hooks
import { clearTablePreferences, getGlobalTablePreferences, resetTablePreferences } from 'src/redux/slices/tablePreferences';
import { resetWhatsAppNotifCount } from 'src/redux/slices/whatsapp';
import useFeaturePermission from 'src/hooks/useFeaturePermission';
import useGetCurrentUser from 'src/hooks/useGetCurrentUser';
import { useOffSetTop, useResponsive, useAuth } from '../../../hooks';
import Iconify from '../../../components/Iconify';
import useDemoMode from '../../../hooks/useDemoMode';
// utils
import { bgBlur } from '../../../utils/cssStyles';
import { localStorageRemoveItem, localStorageGetItem } from '../../../utils/storage-available';
// use config
import { HEADER, NAV } from '../../../config';
// components
import { SvgColor } from '../../../components/svg-color';
import { useSettingsContext } from '../../../components/settings/context';
//
import Searchbar from './Searchbar';
import AccountPopover from './AccountPopover';
import ContactsPopover from './ContactsPopover';
import SettingsPopover from './SettingsPopover';
import SuperAdminPopover from './SuperAdminPopover';
import NotificationsPopover from './NotificationsPopover';
// redux
import { getPracticeTreatmentListData, switchPractice } from '../../../redux/slices/practiceTreatmentList';
import { setReminderData, setToDoData } from '../../../redux/slices/toDoNotifications';
import { addTreatmentsList, clearTreatmentsListForWidget, getChoicesList } from '../../../redux/slices/practiceTreatment';
import { dispatch, useSelector } from '../../../redux/store';
import {
    updateAttendTable,
    updateNewTable,
    updateBookedTable,
    updateArchiveTable,
    updateDashboardTable,
    updateTreatmentStartedTable,
    updateDashNewLeadsTable,
    clearTableData,
    updateCounter,
    updateFailedToAttendTable,
    updateClosedTable,
    clearTaskLead,
    clearSeparateTaskCounter,
    reset as leadReset,
    getMergeTags,
    updateNoTaskTable,
} from '../../../redux/slices/lead';
import { getPracticeData, checkDentallyEnabled } from '../../../redux/slices/practice';
import { prefetchDentallyPractitioners, resetDentallyPractitioners } from '../../../redux/slices/dentallyPractitioners';
import { notificationData } from '../../../redux/slices/user';
import { clearData } from '../../../redux/slices/practiceUser';
import { audienceManagerReset } from '../../../redux/slices/audienceManager';
import { clearTreatmentCategoryReport, reset } from '../../../redux/slices/analytics';
import { reset as practiceIntegrationReset } from '../../../redux/slices/practiceIntegration';
import { reset as chatReset } from '../../../redux/slices/chat';
import { reset as callScriptReset } from '../../../redux/slices/callScript';
import { clearMediaImages } from '../../../redux/slices/campaign';
import { getSchemaList } from '../../../redux/slices/schema';
import { setEmailNotifications, setWpNotifications } from '../../../redux/slices/liveNotificationSlice';
import { setWpTemplateListGlobal } from '../../../redux/slices/whatsAppMessages';
import { fetchMyPermissions } from '../../../redux/slices/permissions';

// ----------------------------------------------------------------------
export default function DashboardHeader({ onOpenSidebar, onOpenCommandPalette }) {
    const theme = useTheme();

    const { themeLayout } = useSettingsContext();

    const isNavHorizontal = themeLayout === 'horizontal';

    const isNavMini = themeLayout === 'mini';

    const isOffset = useOffSetTop(HEADER.DASHBOARD_DESKTOP_HEIGHT) && !isNavHorizontal;

    const navigate = useNavigate();
    const isDesktop = useResponsive('up', 'lg');

    const { practiceId, practiceTreatment, practiceIdToChange } = useSelector((state) => state.practiceTreatmentList);

    const [selectedId, setSelectedId] = useState(Number(practiceId));

    const [demoMode, setDemoMode] = useDemoMode();
    const [demoMenuAnchor, setDemoMenuAnchor] = useState(null);
    const toggleDemoMode = () => setDemoMode((prev) => !prev);

    const { globalTablePreferences } = useSelector((state) => state.tablePreferences);
    const choicesData = useSelector((state) => state.practiceTreatment.choicesData.results);

    const practitionerDashboard = useFeaturePermission('practitioner-dashboard');
    const isPractitionerFlagUser = practitionerDashboard?.canView && !practitionerDashboard?.canManage;
    const dentallyFeature = useFeaturePermission('dentally-integration');
    const { isPractitioner } = useGetCurrentUser();

    const { logout } = useAuth();

    useEffect(() => {
        const data = {
            limit: 10,
            offset: 0
        };
        dispatch(getPracticeTreatmentListData(handleCallBack, data));
    }, []);

    useEffect(() => {
        setSelectedId(practiceId);
        const getReferralData = localStorageGetItem('ReferralData') || [];
        const getMergeTagsData = localStorageGetItem('MergeTagsData') || [];
        const getSourceTypeData = localStorageGetItem('SourceTypeData') || [];
        const getListData = localStorageGetItem('PreferredContactMethodData') || [];
        const getReminderMethodData = localStorageGetItem('ReminderMethodData') || [];
        const getReminderPriorityData = localStorageGetItem('ReminderPriorityData') || [];
        const getReasonsData = localStorageGetItem('ReasonsData') || [];
        const getContactMethodData = localStorageGetItem('ContactMethodData') || [];
        const getAppointmentTypeData = localStorageGetItem('AppointmentTypeData') || [];
        const getAppointmentMethodData = localStorageGetItem('AppointmentMethodData') || [];
        const getSalutationOptionsData = localStorageGetItem('SalutationOptions') || [];
        const getArchiveReasonsData = localStorageGetItem('ArchiveReasonsData') || [];
        const getFinanceTermOptionsData = localStorageGetItem('FinanceTermOptions') || [];
        const getreportTypeData = localStorageGetItem('ReportTypeData') || [];
        const getRefundPaymentReasonData = localStorageGetItem('RefundPaymentReasonData') || [];
        if (getListData?.length === 0 || getReferralData?.length === 0 || getSourceTypeData?.length === 0 || getReminderMethodData?.length === 0 || getReminderPriorityData?.length === 0 || getReasonsData?.length === 0 || getContactMethodData?.length === 0 || getAppointmentTypeData?.length === 0 || getAppointmentMethodData?.length === 0 || getSalutationOptionsData?.length === 0 || getArchiveReasonsData?.length === 0 || getFinanceTermOptionsData?.length === 0 || getreportTypeData?.length === 0 || getRefundPaymentReasonData?.length === 0) {
            // Defer schema fetch by 3s so it doesn't compete with critical
            // dashboard data calls (leads, widgets, merge tags) in the
            // connection pool. Schema takes ~2.8s and blocks 1 of 10 slots.
            setTimeout(() => dispatch(getSchemaList()), 3000);
        }
        if (isEmpty(globalTablePreferences)) {
            dispatch(getGlobalTablePreferences());
        }
        if (isEmpty(choicesData) && practiceId) {
            dispatch(getChoicesList(practiceId));
        }
        // Early Dentally enabled check — fires every time practiceId changes.
        // Skip entirely when the dentally-integration feature flag is hidden
        // for this practice — the API returns 403 and creates Sentry noise.
        // Also skip for Practitioner role users who don't need this data.
        if (practiceId && isPractitioner === false && dentallyFeature?.canView) {
            dispatch(checkDentallyEnabled(practiceId));
            dispatch(prefetchDentallyPractitioners(practiceId));
        }
        if (getMergeTagsData?.length === 0) {
            dispatch(getMergeTags());
        }
    }, [practiceId, isPractitioner, dentallyFeature?.canView]);

    const handleCallBack = async () => {
        await logout();
    };

    const changeValue = (id) => {
        setSelectedId(id);
        dispatch(switchPractice(id));
    };

    const onChangeSelect = (event) => {
        const triggeredFromInterPracticePage = event?.target?.type === "INTER-PRACTICE-CHANGE" ?? false;
        if (!triggeredFromInterPracticePage)
            navigate('/dashboard');
        changeValue(event.target.value);
        dispatch(reset());
        dispatch(resetTablePreferences());
        dispatch(clearTablePreferences());
        dispatch(clearTreatmentsListForWidget());
        dispatch(practiceIntegrationReset());
        dispatch(setToDoData([]));
        dispatch(setEmailNotifications([]));
        dispatch(setWpNotifications([]));
        dispatch(setReminderData([]));
        dispatch(chatReset());
        dispatch(callScriptReset());
        dispatch(audienceManagerReset());
        dispatch(resetDentallyPractitioners());
        dispatch(addTreatmentsList([]));
        dispatch(clearTableData());
        dispatch(getPracticeData({}));
        dispatch(updateCounter([]));
        dispatch(clearTaskLead());
        dispatch(clearData());
        dispatch(clearSeparateTaskCounter());
        dispatch(clearTreatmentCategoryReport());
        dispatch(clearMediaImages());
        dispatch(setWpTemplateListGlobal(null));
        dispatch(notificationData([{
            results: [],
            count: 0
        }]));
        dispatch(updateArchiveTable({
            pageNumber: 0,
            perPage: 10,
        }));
        dispatch(updateDashNewLeadsTable({
            count: '0',
            labelCounter: 0,
            pageNumber: 0,
            perPage: 10,
            order: 'desc',
            orderValue: 'created_at',
            search: '',
            treatment: [],
            date: [],
            status: 'NEW',
            tag: [],
            filterTags: [],
            referral: ''
        }));
        dispatch(updateBookedTable({
            count: 'All',
            pageNumber: 0,
            perPage: 10,
            order: 'desc',
            orderValue: 'created_at',
            search: '',
            treatment: [],
            date: [],
            status: 'CONSULTATION_BOOKED',
            tag: [],
            filterTags: [],
            referral: '',
            bookedWith: 0
        }));
        dispatch(updateFailedToAttendTable({
            pageNumber: 0,
            perPage: 10,
            order: 'desc',
            orderValue: 'created_at',
            search: '',
            treatment: [],
            date: [],
            status: 'FAILED_TO_ATTEND_CONSULTATION',
            tag: [],
            filterTags: [],
            referral: '',
        }));
        dispatch(updateClosedTable({
            pageNumber: 0,
            perPage: 10,
            order: 'desc',
            orderValue: 'created_at',
            search: '',
            treatment: [],
            date: [],
            status: 'CLOSED',
            tag: [],
            filterTags: [],
            referral: ''
        }));
        dispatch(updateAttendTable({
            count: '0',
            pageNumber: 0,
            perPage: 10,
            order: 'desc',
            orderValue: 'created_at',
            search: '',
            treatment: [],
            date: [],
            status: 'CONSULTATION_ATTENDED',
            tag: [],
            filterTags: [],
            referral: '',
            bookedWith: 0
        }));
        dispatch(updateNewTable({
            count: '0',
            pageNumber: 0,
            perPage: 10,
            order: 'desc',
            orderValue: 'created_at',
            search: '',
            treatment: [],
            date: [],
            status: 'NEW',
            tag: [],
            filterTags: [],
            referral: ''
        }));
        dispatch(updateTreatmentStartedTable({
            pageNumber: 0,
            perPage: 10,
            order: 'desc',
            orderValue: 'created_at',
            search: '',
            treatment: [],
            date: [],
            status: 'TREATMENT_STARTED',
            tag: [],
            filterTags: [],
            referral: '',
            category: '0'
        }));
        if (!triggeredFromInterPracticePage)
            dispatch(updateDashboardTable({
                count: 'All',
                pageNumber: 0,
                perPage: 10,
                order: 'desc',
                orderValue: 'created_at',
                search: '',
                treatment: [],
                date: [],
                status: 'TREATMENT_STARTED',
                tag: [],
                filterTags: [],
                referral: ''
            }));
        dispatch(updateNoTaskTable({
            count: 'All',
            pageNumber: 0,
            perPage: 10,
            order: 'desc',
            orderValue: 'created_at',
            search: '',
            treatment: [],
            date: [],
            status: 'All',
            tag: [],
            filterTags: [],
            referral: ''
        }));
        localStorageRemoveItem('dateFormat');
        localStorageRemoveItem('ReferralData');
        localStorageRemoveItem('SourceTypeData');
        localStorageRemoveItem('PreferredContactMethodData');
        localStorageRemoveItem('ReminderMethodData');
        localStorageRemoveItem('ReminderPriorityData');
        localStorageRemoveItem('AppointmentTypeData');
        localStorageRemoveItem('AppointmentMethodData');
        localStorageRemoveItem('FinanceTermOptions');
        localStorageRemoveItem('ReportTypeData');
        localStorageRemoveItem('SalutationOptions');
        localStorageRemoveItem('ArchiveReasonsData');
        localStorageRemoveItem('RefundPaymentReasonData');
        localStorageRemoveItem('ContactMethodData');
        localStorageRemoveItem('ReasonsData');
        localStorageRemoveItem('MergeTagsData');
        localStorageRemoveItem('reminderData');
        localStorageRemoveItem('timeout_ids');
        // NOTE: do NOT eagerly clearPermissions() here. Doing so causes
        // `hasTasksV2` to flip to false during the fetchMyPermissions network
        // window, briefly pointing the Tasks nav entry at the wrong URL and
        // flashing the wrong V2 chip state. `setPermissions` overwrites
        // atomically when the response arrives — the previous practice's
        // permissions are safe to keep visible for the ~300ms in between.
        // clearPermissions() is still called on logout in JWTContext.jsx.
        dispatch(fetchMyPermissions(event.target.value));
        dispatch(leadReset());
        dispatch(resetWhatsAppNotifCount());
    };

    useEffect(() => {
        if (!practiceIdToChange) return;
        onChangeSelect({ target: { value: practiceIdToChange, type: "INTER-PRACTICE-CHANGE" } });
    }, [practiceIdToChange]);

    const hasMultiplePractices = (practiceTreatment?.results?.length || 0) > 1;

    const renderContent = (
        <>

            {!isDesktop && !isPractitionerFlagUser && (
                <IconButton onClick={onOpenSidebar} sx={{ mr: 1, color: 'text.primary' }}>
                    <SvgColor src="/assets/icons/navbar/ic_menu_item.svg" />
                </IconButton>
            )}

            {!isPractitionerFlagUser && hasMultiplePractices && (
                <Stack direction="row" alignItems="center" spacing={0.5} sx={{ mr: { sm: 2, xs: 0.5 } }}>
                    <Tooltip title={demoMode ? 'Demo mode on — practice name hidden. Click to disable.' : 'Hide practice name (demo mode)'}>
                        <IconButton
                            size="small"
                            onClick={toggleDemoMode}
                            sx={{ mt: 0.5, color: demoMode ? 'warning.main' : 'text.secondary' }}
                            data-testid="practice-demo-mode-toggle"
                        >
                            <Iconify icon={demoMode ? 'eva:eye-off-fill' : 'eva:eye-outline'} width={18} height={18} />
                        </IconButton>
                    </Tooltip>
                    {demoMode ? (
                        <>
                            <Button
                                variant="outlined"
                                size="small"
                                onClick={(e) => setDemoMenuAnchor(e.currentTarget)}
                                endIcon={<Iconify icon="eva:chevron-down-fill" width={16} height={16} />}
                                data-testid="practice-demo-button"
                                sx={{
                                    mt: 0.5,
                                    width: { xs: 140, sm: 200, md: 250 },
                                    flexShrink: 0,
                                    justifyContent: 'space-between',
                                    fontSize: { sm: '14px', xs: '13px' },
                                    fontWeight: 400,
                                    color: 'text.primary',
                                    borderColor: 'rgba(145, 158, 171, 0.32)',
                                    textTransform: 'none',
                                }}
                            >
                                Practice
                            </Button>
                            <Menu
                                anchorEl={demoMenuAnchor}
                                open={Boolean(demoMenuAnchor)}
                                onClose={() => setDemoMenuAnchor(null)}
                                slotProps={{ paper: { sx: { minWidth: 250 } } }}
                            >
                                {(practiceTreatment?.results || []).map((p, i) => (
                                    <MenuItem
                                        key={p.id}
                                        selected={`${p.id}` === `${selectedId}`}
                                        onClick={() => {
                                            if (`${p.id}` !== `${selectedId}`) {
                                                onChangeSelect({ target: { value: `${p.id}` } });
                                            }
                                            setDemoMenuAnchor(null);
                                        }}
                                    >
                                        {`Practice ${i + 1}`}
                                    </MenuItem>
                                ))}
                            </Menu>
                        </>
                    ) : (
                        <Autocomplete
                            id="select-practice-search"
                            options={practiceTreatment?.results || []}
                            getOptionLabel={(option) => option.name || ''}
                            value={practiceTreatment?.results?.find((p) => `${p.id}` === `${selectedId}`) || null}
                            onChange={(_, newValue) => {
                                if (newValue) {
                                    onChangeSelect({ target: { value: `${newValue.id}` } });
                                }
                            }}
                            isOptionEqualToValue={(option, value) => `${option.id}` === `${value.id}`}
                            disableClearable
                            size="small"
                            sx={{
                                mt: 0.5,
                                width: { xs: 140, sm: 200, md: 250 },
                                flexShrink: 0,
                                '& .MuiOutlinedInput-root': {
                                    fontSize: { sm: '14px', xs: '13px' },
                                },
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Select Practice"
                                    InputLabelProps={{
                                        ...params.InputLabelProps,
                                        sx: { fontSize: { sm: '14px', xs: '13px' } },
                                    }}
                                />
                            )}
                        />
                    )}
                </Stack>
            )}

            {!isPractitionerFlagUser && <Searchbar onOpenCommandPalette={onOpenCommandPalette} />}

            <Stack
                flexShrink={0}
                direction="row"
                alignItems="center"
                justifyContent="flex-end"
                spacing={{ xs: 0.5, sm: 1 }}
                sx={{ ml: 'auto' }}
            >
                {isPractitionerFlagUser ? <AccountPopover /> : (
                    <>
                        <NotificationsPopover />
                        <ContactsPopover />
                        <SuperAdminPopover />
                        <SettingsPopover />
                        <AccountPopover />
                    </>
                )}
            </Stack>
        </>
    );

    return (
        <AppBar
            sx={{
                boxShadow: 'none',
                height: HEADER.H_MOBILE,
                zIndex: theme.zIndex.appBar + 1,
                ...bgBlur({
                    color: theme.palette.background.default,
                }),
                transition: theme.transitions.create(['height'], {
                    duration: theme.transitions.duration.shorter,
                }),
                ...(isDesktop && {
                    width: `calc(100% - ${NAV.W_DASHBOARD + 1}px)`,
                    height: HEADER.H_DASHBOARD_DESKTOP,
                    ...(isOffset && {
                        height: HEADER.H_DASHBOARD_DESKTOP_OFFSET,
                    }),
                    ...(isNavHorizontal && {
                        width: 1,
                        bgcolor: 'background.default',
                        height: HEADER.H_DASHBOARD_DESKTOP_OFFSET,
                        borderBottom: `dashed 1px ${theme.palette.divider}`,
                    }),
                    ...(isNavMini && {
                        width: `calc(100% - ${NAV.W_DASHBOARD_MINI + 1}px)`,
                    }),
                }),
            }}
        >
            <Toolbar
                sx={{
                    height: 1,
                    px: { lg: 3 },
                }}
            >
                {renderContent}
            </Toolbar>
        </AppBar>
    );
}

DashboardHeader.propTypes = {
    onOpenSidebar: PropTypes.func,
    onOpenCommandPalette: PropTypes.func,
};